import { ModalFormId } from 'src/components/ModalForms'

export const GOOGLE_API_SRC = 'https://apis.google.com/js/api.js'
export const GOOGLE_GSI_CLIENT_SRC = 'https://accounts.google.com/gsi/client'

// Scope requested from the signed-in user for the Picker. drive.file is the
// narrowest scope the Picker accepts and is not a Google "restricted" scope,
// so it needs no restricted-scope app verification. The backend never uses
// this token; it reads Drive with the receptor's service account.
export const GOOGLE_PICKER_USER_SCOPE =
  'https://www.googleapis.com/auth/drive.file'

export const GOOGLE_PICKER_SUPPORTED_FILE_TYPES =
  'application/vnd.google-apps.folder,image/png,image/jpeg,.rtf,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.pages,.csv,.xlsx,.xls,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.ppt,.pptx,.key,.numbers,application/vnd.google-apps.document,application/vnd.google-apps.spreadsheet,application/vnd.google-apps.presentation,application/pdf'

export type PickerConfiguration = {
  allowMultiselect: boolean
  viewId: google.picker.ViewId
  selectFolderEnabled?: boolean
  modalId: ModalFormId
  mimeTypes?: string
  selectableMimeTypes?: string
}

export type PickerResponse = {
  isShown: boolean
  invalidCredentials: boolean
  exceptions: string
}
